import { Code, Flex } from '@radix-ui/themes'

export const AppVersion = () => (
  <Flex justify="center" py="2">
    <Code size="1" style={{ color: 'var(--gray-8)', backgroundColor: 'var(--gray-3)' }}>
      {__APP_VERSION__}
    </Code>
  </Flex>
)
